import { render, staticRenderFns } from "./notFindComponent.vue?vue&type=template&id=8a41ec80"
import script from "./notFindComponent.vue?vue&type=script&lang=js"
export * from "./notFindComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports